import React, { Component } from 'react'
import { Icon, Table, Input } from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';

import { get_letter } from '../actions/print.action';

// Styles
import './../style.css';

class DvSaleryTransCertificate extends Component {

    constructor( props ){
        super( props );

        this.state = {
            data: [],
            to_position: "The Manager",
            to_address: "MASHREQ BANK",
            to_location: "Dubai",
            to_salary: 1000,
            to_account: 80008000800,
            to_hr: 'Sajina Salim',
            to_hr_position: 'Finance Manager',
        }

    }

    componentWillMount(){
        this.props.get_letter( this.props.match.params.id );
    }

    componentWillReceiveProps( nextProps ){

        console.log( nextProps );
        
        if( nextProps.print.length != 0 ){
            this.setState({
                data: nextProps.print.OUTPUT.DATA[0]
            })

            setTimeout(() => {
                // window.print();
            },500)

        }

    }

    handleDate_formate( date ){
        return moment( date ).format('Do of MMMM YYYY');
    }

    handleHonorific( status, gender ){

        if( gender === 'male' ){
            if( status === 'married' || status === 'single' ){
                return 'Mr.';
            }
        }

        if( gender === 'female' ){
            if( status === 'married' ){
                return 'Mrs.';
            }
            if( status === 'single' ){
                return 'Miss.';
            }

        }

    }

    convertNumberToWords( amount ) {

        if( isNaN( amount ) === true ){
            return '';
        }

        let dec = amount.toString().split(".");

        var n = dec[0];

        var string = n.toString(), units, tens, scales, start, end, chunks, chunksLen, chunk, ints, i, word, words, and = 'and';

        /* Remove spaces and commas */
        string = string.replace(/[, ]/g,"");

        /* Is number zero? */
        if( parseInt( string ) === 0 ) {
            return 'Zero';
        }
        
        /* Array of units as words */
        units = [ '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen' ];
        
        /* Array of tens as words */
        tens = [ '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety' ];
        
        /* Array of scales as words */
        scales = [ '', 'Thousand', 'Million', 'Billion', 'Trillion', 'Quadrillion', 'Quintillion', 'Sextillion', 'Septillion', 'Octillion', 'Nonillion', 'Decillion', 'Undecillion', 'Duodecillion', 'Tredecillion', 'Quatttuor-Decillion', 'Quindecillion', 'Sexdecillion', 'Septen-Decillion', 'Octodecillion', 'Novemdecillion', 'Vigintillion', 'Centillion' ];
        
        /* Split user argument into 3 digit chunks from right to left */
        start = string.length;
        chunks = [];
        while( start > 0 ) {
            end = start;
            chunks.push( string.slice( ( start = Math.max( 0, start - 3 ) ), end ) );
        }
        
        /* Check if function has enough scale words to be able to stringify the user argument */
        chunksLen = chunks.length;
        if( chunksLen > scales.length ) {
            return '';
        }
        
        /* Stringify each integer in each chunk */
        words = [];
        for( i = 0; i < chunksLen; i++ ) {
            
            chunk = parseInt( chunks[i] );
            
            if( chunk ) {
                
                /* Split chunk into array of individual integers */
                ints = chunks[i].split( '' ).reverse().map( parseFloat );
            
                /* If tens integer is 1, i.e. 10, then add 10 to units integer */
                if( ints[1] === 1 ) {
                    ints[0] += 10;
                }
                
                /* Add scale word if chunk is not zero and array item exists */
                if( ( word = scales[i] ) ) {
                    words.push( word );
                }
                
                /* Add unit word if array item exists */
                if( ( word = units[ ints[0] ] ) ) {
                    words.push( word );
                }
                
                /* Add tens word if array item exists */
                if( ( word = tens[ ints[1] ] ) ) {
                    words.push( word );
                }
                
                /* Add 'and' string after units or tens integer if: */
                if( ints[0] || ints[1] ) {
                    
                    /* Chunk has a hundreds integer or chunk is the first of multiple chunks */
                    if( ints[2] || ! i && chunksLen ) {
                        words.push( and );
                    }
                
                }
                
                /* Add hundreds word if array item exists */
                if( ( word = units[ ints[2] ] ) ) {
                    words.push( word + ' Hundred' );
                }
                
            }
            
        }
        
        var words_string =  words.reverse().join( ' ' );

        if( dec[1] ){
            return words_string + ' and ' + dec[1] + ' / 100 ';
        } else {
            return words_string;
        }
        
    }

    render() {
        return (
            <div className="print_wrapper letter">
                
                <table width="100%">

                    <thead>
                        <tr>
                            <th colSpan="2">
                                <span className="print_logo"></span>
                                <span className="jgroup_logo"></span>
                            </th>
                        </tr>
                    </thead>

                    <tbody>

                        <tr>
                            <td valign="top">

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '60px' }}>&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td style={{textAlign: 'right'}}>Date: { this.handleDate_formate( this.state.data.request_date ) }</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '60px' }}>&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>
                                
                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%">
                                                <Input 
                                                    style={{width: '300px', marginRight: '15px' }} 
                                                    value={ this.state.to_position }
                                                    onChange={ (e)=> this.setState({ to_position: e.target.value }) } />
                                                { this.state.to_position } </td>
                                        </tr>
                                        <tr>
                                            <td width="100%">
                                                <Input 
                                                    style={{width: '300px', marginRight: '15px' }} 
                                                    value={ this.state.to_address }
                                                    onChange={ (e)=> this.setState({ to_address: e.target.value }) } />
                                                <b>{ this.state.to_address }</b></td>
                                        </tr>
                                        <tr>
                                            <td width="100%">
                                                <Input 
                                                    style={{width: '300px', marginRight: '15px' }} 
                                                    value={ this.state.to_location }
                                                    onChange={ (e)=> this.setState({ to_location: e.target.value }) } />
                                                { this.state.to_location }</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <Input 
                                                    style={{width: '300px', marginRight: '15px' }} 
                                                    value={ this.state.to_salary }
                                                    onChange={ (e)=> this.setState({ to_salary: e.target.value }) } />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <Input 
                                                    style={{width: '300px', marginRight: '15px' }} 
                                                    value={ this.state.to_account }
                                                    onChange={ (e)=> this.setState({ to_account: e.target.value }) } />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '30px' }}>&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%">
                                                <h2 style={{ textAlign: 'center', textDecoration: 'underline' }}>REF: Salary Transfer Letter</h2>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '30px' }}>&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%">Dear Sir/ Madam,</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '10px' }}>&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>

                                {/* <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ textAlign: 'justify' }}>
                                                This is to certify that <b>{ this.handleHonorific( this.state.data.marital_status, this.state.data.gender ) }&nbsp;
                                                { this.state.data.full_name }</b>, holder of&nbsp;
                                                { this.state.data.country } Passport no.&nbsp;
                                                { this.state.data.passport_number } is working with&nbsp;
                                                { this.state.data.company_name } &nbsp;since &nbsp;
                                                { this.handleDate_formate( this.state.data.date_of_joining ) }&nbsp;as&nbsp;
                                                { this.state.data.designation_name }. &nbsp;
                                                { (this.state.data.gender === 'male') ? 'His': 'Her' }&nbsp;current remuneration is&nbsp;
                                                { this.convertNumberToWords( this.state.to_salary ) }&nbsp;{ this.state.data.company_currency } ( { Math.abs( this.state.to_salary ).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }&nbsp;{this.state.data.company_currency}/ ) inclusive of all allowances.
                                            </td>
                                        </tr>
                                    </tbody>
                                </table> */}

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ textAlign: 'justify' }}>
                                                We hereby certify that Mr/Ms.&nbsp;
                                                { this.state.data.full_name } holder of&nbsp;
                                                { this.state.data.country } (name of country) with the passport number&nbsp;
                                                { this.state.data.passport_number } is an employee of&nbsp;
                                                { this.state.data.company_name } since&nbsp;
                                                { this.handleDate_formate( this.state.data.date_of_joining ) }, as a&nbsp;
                                                { this.state.data.designation_name } (designation). { (this.state.data.gender === 'male') ? 'His': 'Her' }&nbsp; monthly remuneration is { this.state.data.company_currency }&nbsp;
                                                { Math.abs( this.state.to_salary ).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }&nbsp;( figures) inclusive of all fixed allowances. 
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '10px' }}>&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ textAlign: 'justify' }}>
                                            We confirm that we will transfer directly his/her net salary each month into his account #{ this.state.to_account }&nbsp;with you. We will not transfer his/her salary to any other bank or account unless we get a ‘No Objection’ letter/certificate from you. Should the employment cease, the company will notify you accordingly.
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '10px' }}>&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ textAlign: 'justify' }}>
                                                This letter is issued upon the employee’s request, and it does not constitute a financial guarantee on our part.
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '60px' }}>&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%">Yours sincerely,</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: '60px' }}>&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%">
                                                <Input 
                                                    style={{width: '300px', marginRight: '15px' }} 
                                                    value={ this.state.to_hr }
                                                    onChange={ (e)=> this.setState({ to_hr: e.target.value }) } />
                                                <b>{ this.state.to_hr }</b></td>
                                        </tr>
                                        <tr>
                                            <td width="100%">
                                                <Input 
                                                    style={{width: '300px', marginRight: '15px' }} 
                                                    value={ this.state.to_hr_position }
                                                    onChange={ (e)=> this.setState({ to_hr_position: e.target.value }) } />
                                                { this.state.to_hr_position }</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </td>
                        </tr>

                    </tbody>

                    <tfoot>
                        <tr>
                            <td width="100%" valign="top" colSpan={0}>

                                <table width="100%" className="fixed_footer">
                                    <tbody>
                                        <tr>
                                            <td valign="top" width="33.33%" style={{ color: '#999' }}>
                                                <span><b>{ this.state.data.company_name }</b></span>
                                                <span>{ this.state.data.website }</span>
                                            </td>
                                            <td valign="top" width="33.33%" style={{ color: '#999' }}>
                                                <span style={{width: '80%'}}>
                                                <i className="footer_icon maps_flags" />    
                                                { this.state.data.company_address }</span>
                                            </td>
                                            <td valign="top" width="33.33%" style={{ color: '#1185db' }}>
                                                <span><i className="footer_icon phone_call" />{ this.state.data.phone1 }</span>
                                                <span><i className="footer_icon email" />{ this.state.data.email }</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </td>
                        </tr>
                    </tfoot>

                </table>


            </div>
        )
    }
}

function mapStatetoProps( state ){
    return {
        print: state.print
    }
}

export default connect( mapStatetoProps, { get_letter } )( DvSaleryTransCertificate );



// WEBPACK FOOTER //
// ./src/pages/prints/dv-salary-trans-certificate/index.js